/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions, FindOptions } from './common';
import {
  FindProductsWithExcludedProductsType,
  FindProductsQuery,
  FindProductsForCreatePolicyQuery,
  FindCollaboratorProductsType,
} from './product';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-products';

export const EntityProductApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findFreeProductsForCombo: async (
    params: FindProductsWithExcludedProductsType
  ) => {
    let url = `${pathname}/free-products-for-combo`;
    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForTableList: async (option: FindEntityProductsQuery) => {
    let url = `${pathname}/find-products-for-table-list`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: UpdateEntityProductBody) => {
    try {
      const response = await entityService.patch(`${pathname}/${id}`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateMulti: async (body: UpdateMultiEntityProductsBody) => {
    try {
      const response = await entityService.patch(`${pathname}/multi`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateTotalReceivedQuantity: async (id: string, options: any, body: any) => {
    let url = `${pathname}/update-total-received-quantity/${id}`;
    const query = serialize(options);
    url += query;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  divideTotalReceivedQuantityAmongOrders: async (
    options: any,
    body: DivideEntityProductTotalReceivedQuantityAmongOrdersBody
  ) => {
    let url = `${pathname}/divide-total-received-quantity-v2`;
    const query = serialize(options);
    url += query;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  divideTotalReceivedQuantityAmongOrdersOlder: async (
    options: any,
    body: DivideEntityProductTotalReceivedQuantityAmongOrdersBody
  ) => {
    let url = `${pathname}/divide-total-received-quantity`;
    const query = serialize(options);
    url += query;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findToOrderChainSupplier: async (
    params: FindEntityProductsToOrderChainSupplierOptions
  ) => {
    let url = `${pathname}/find-with-proposal-items/order-chain-suppliers`;
    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findToBalance: async (params: FindEntityProductsToBalanceOptions) => {
    let url = `${pathname}/find-with-order-items/balance`;
    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithProductionPlanProductForecastToBalance: async (
    params: FindEntityProductsWithProductionPlanProductForecastToBalanceOptions
  ) => {
    let url = `${pathname}/find-with-production-plan-product-forecast/balance`;
    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityProductsForTableList: async (
    option: FindEntityProductsForTableListQuery
  ) => {
    let url = `${pathname}/find-for-table-list`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filterForTableList: async (option: FindEntityProductsForTableListQuery) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkExistEntityProducts: async (
    entityIDs: string[],
    entityProductIDs: string[]
  ) => {
    const url = `${pathname}/check-exist-entity-products`;

    try {
      const response = await entityService.post(url, {
        entityIDs,
        entityProductIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkExistEntityProductsOptimize: async (
    entityIDs: string[],
    entityProductIDs: string[]
  ) => {
    const url = `${pathname}/check-exist-entity-products-optimize`;

    try {
      const response = await entityService.post(url, {
        entityIDs,
        entityProductIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsByEntitySubCategory: async (option: FindEntityProductsQuery) => {
    let url = `${pathname}/find-products-by-entity-sub-category`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForMarketing: async (option: FindEntityProductsQuery) => {
    let url = `${pathname}/find-products-for-marketing`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForMarketingWithExcludedProducts: async (
    params: FindProductsWithExcludedProductsType
  ) => {
    let url = `${pathname}/find-products-for-marketing`;

    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCollaboratorProductsForTableList: async (
    options: FindCollaboratorProductsType
  ) => {
    let url = `${pathname}/find-collaborator-products-for-table-list`;
    const { entityIDs, ...params } = options;
    const query = serialize(params);
    url += query;

    try {
      const response = await entityService.post(url, entityIDs);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForSyncChain: async (option: FindProductsQuery) => {
    let url = `${pathname}/find-products-for-sync-chain`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityProductForUpdate: async (id: string) => {
    const url = `${pathname}/entity/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  // TODO: Need replace by filterForSelect
  findProductsForSingleSelect: async (option: FindProductsQuery) => {
    let url = `${pathname}/find-products-for-single-select`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (
    option: FilterEntityProductOptions,
    body?: { ninIDs: string[] }
  ) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsHaveCoBuyPromotion: async (
    params: FindProductsWithExcludedProductsType
  ) => {
    let url = `${pathname}/find-products-have-co-buy-promotion`;

    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForMultiSelect: async (option: FindProductsQuery) => {
    let url = `${pathname}/find-products-for-multi-select`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForReportQuantity: async (
    option: FindEntityProductForReportQuantityType
  ) => {
    let url = `${pathname}/find-product-for-report-quantity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForCreatePolicy: async (
    options: FindProductsForCreatePolicyQuery
  ) => {
    let url = `${pathname}/find-products-for-create-policy`;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsWithTotalStatistics: async (option: FindEntityProductsQuery) => {
    let url = `${pathname}/find-products-with-total-statistics`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForCreateAnonymousAccount: async (
    option: FindEntityProductsQuery
  ) => {
    let url = `${pathname}/find-products-for-create-anonymous-account`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForTableListWithExcludedProducts: async (
    params: FindProductsWithExcludedProductsType
  ) => {
    let url = `${pathname}/find-for-table-list`;
    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForTableListWithExcludedProducts: async (
    params: FindProductsWithExcludedProductsType
  ) => {
    let url = `${pathname}/find-products-for-table-list`;
    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForCoBuy: async (
    params: FindProductsWithExcludedProductsType
  ) => {
    let url = `${pathname}/find-products-for-co-buy`;
    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params?.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsForRetailDigitalMenu: async (
    params: FindProductsWithExcludedProductsType
  ) => {
    let url = `${pathname}/find-products-for-retail-digital-menu`;
    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithPartnerEntityProducts: async (
    option: FindWithPartnerEntityProductsQuery
  ) => {
    let url = `${pathname}/partner-entity-products`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithPartnerEntityProductsForCollaborator: async (
    option: FindWithPartnerEntityProductsQuery
  ) => {
    let url = `${pathname}/partner-entity-products-for-collaborator`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findFreePartnerEntityProducts: async (
    option: FindFreePartnerEntityProductsQuery
  ) => {
    let url = `${pathname}/free-partner-entity-products`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneWithID: async (id: string) => {
    const url = `${pathname}/find-product-with-id/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  closeReuseDiary: async (id: string) => {
    const url = `${pathname}/close-reuse-diary/${id}`;
    try {
      const response = await entityService.patch(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteMulti: async (body: { entityProductIDs: string[] }) => {
    try {
      const response = await entityService.post(
        `${pathname}/delete/multi`,
        body
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCanDelete: async (id: string) => {
    const url = `${pathname}/check-can-delete/${id}`;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCanDeleteMulti: async (body: { entityProductIDs: string[] }) => {
    const url = `${pathname}/check-can-delete-multi`;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsToConnect: async (options: FindEntityProductsQuery) => {
    let url = `${pathname}/find-products-to-connect`;
    const query = serialize({
      ...options,
    });
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  findSelectedEntityProductsToCreatePolicy: async (
    body: { productIDs: string[] },
    option: FindOptions
  ) => {
    let url = `${pathname}/find-selected-products-to-create-policy`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  getDataFromGGSheet: async (option: ImportEntityProductsFromGGSheet) => {
    let url = `${pathname}/import`;
    option.googleSheetUrl = encodeURIComponent(option.googleSheetUrl);
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  getDataFromXLSX: async (body: RawEntityProduct[]) => {
    const url = `${pathname}/preview`;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  import: async (option: ImportEntityProductsFromGGSheet) => {
    let url = `${pathname}/import`;
    option.googleSheetUrl = encodeURIComponent(option.googleSheetUrl);
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.post(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  importXLSX: async (body: ValidEntityProduct[]) => {
    const url = `${pathname}/import-xlsx`;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  exportEntityProducts: async (body: { entityProductIDs: string[] }) => {
    const url = `${pathname}/export`;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  resetTotalSupplierQuantity: async (
    options: any,
    body: ResetEntityProductTotalSupplierQuantityBody
  ) => {
    let url = `${pathname}/reset-total-supplier-quantity-v2`;

    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  resetTotalSupplierQuantityOlder: async (
    options: any,
    body: ResetEntityProductTotalSupplierQuantityBody
  ) => {
    let url = `${pathname}/reset-total-supplier-quantity`;

    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  resetTotalReceivedQuantity: async () => {
    const url = `${pathname}/reset-total-received-quantity`;

    try {
      const response = await entityService.patch(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  recalculateTotalReceivedQuantity: async (
    options: any,
    body: RecalculateTotalReceivedQuantityBody
  ) => {
    let url = `${pathname}/recalculate-total-received-quantity`;

    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductsToConnectNewEntity: async (option: FindProductsQuery) => {
    let url = `${pathname}/find-products-to-connect-new-entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface BaseEntityProduct {
  entityID?: string;
  shortID?: string;
  entitySubCategoryID?: string;
  productID?: string;
  status?: number;
  totalRating?: number;
  totalRatingPoint?: number;
  avgRating?: number;
  soldQuantity?: number;
}

export interface EntityProductType extends BaseEntityProduct {
  id: string;
}

type FindOptionsVer1 = Pick<
  FindOptions,
  Exclude<keyof FindOptions, 'select' | 'relations' | 'where' | 'tab'>
>;

export type FindEntityProductForReportQuantityType = {
  page: number;
  take: number;
  order?: any;

  entityCategoryID?: string;
  name?: string;
  status: number;
};

export type FindEntityProductsQuery = {
  page?: number;
  take?: number;
  order?: any;
  status?: number | string;
  entityCategoryID?: string;
  name?: string;
  entityID?: string;
  reserved?: boolean;
  entitySubCategoryID?: string;
};

export type FindEntityProductsForTableListQuery = {
  page?: number;
  take?: number;
  order?: any;
  statuses?: (number | string)[] | undefined;
  entityCategoryID?: string;
  name?: string;
  entityID?: string;
  reserved?: boolean;
  entitySubCategoryID?: string;
  shouldReturnHeirEntities?: boolean;
};

export interface FindWithPartnerEntityProductsQuery extends FindOptionsVer1 {
  customerID: string;
  supplierID: string;
  categoryID?: string;
  entityCategoryID?: string;
  supplierProductName?: string;
  customerProductName?: string;
}

export interface FindFreePartnerEntityProductsQuery extends FindOptionsVer1 {
  partnerID: string;
  categoryID?: string;
  entityCategoryID?: string;
  name?: string;
}

export interface ImportEntityProductsFromGGSheet {
  googleSheetUrl: string;
  sheetName: string;
}

export interface RawEntityProduct {
  code: string;
  name: string;
  entityCategoryName: string;
  entitySubCategoryName: string;
  avatar: string;
  productMedias: string;
  hasQRCode: boolean;
  hasCert: boolean;
  hasFreeShipping: boolean;
  content: string;
  description: string;
  productQuestions: string;
  price: string;
  rawRetailUnit: string;
  rawReportQuantity?: string;
  relativeQuantity: number;
  absoluteQuantity: number;
  reportType: number;
  isQuantityAutoUpdated: boolean;
  hasProposedQuantity: boolean;
  rawWholesalePriceUnit: any[];
}
export interface ValidEntityProduct extends RawEntityProduct {
  entityCategoryID: string;
  retailUnit: any;
  entitySubCategoryID: string;
  wholesalePriceUnit: any[];
  checkValidData: any;
  isValidData: boolean;
  questions: { answer: string; content: string }[];
}

export interface UpdateEntityProductBody {
  isPublic?: boolean;
  isEnabledContactPrice?: boolean;
}

export interface UpdateMultiEntityProductsBody {
  entityProductIDs: string[];
  entityProduct: UpdateEntityProductBody;
}

export type FindEntityProductsToOrderChainSupplierOptions = {
  options: {
    page: number;
    take: number;
    autoOrderSettingDetailPage?: number;
    autoOrderSettingDetailTake?: number;
    entityCategoryID?: string;
    name?: string;
    totalCustomerOrderQuantity?: any;
    totalSupplierProposedQuantity?: any;
    totalOrderQuantityToSupplier?: any;
    totalMissingOrRedundantQuantity?: any;
    order?: any;
  };
  body: {
    autoOrderSettingDetails: any;
    entitySubCategoryIDs: string[];
  };
};

export type FindEntityProductsToBalanceOptions = {
  options: {
    page: number;
    take: number;
    ordersPage?: number;
    ordersTake?: number;
    entityCategoryID?: string;
    name?: string;
    totalCustomerOrderQuantity?: any;
    totalReceivedQuantity?: any;
    totalSupplierQuantity?: any;
    totalMissingOrRedundantReceivedQuantity?: any;
    totalIncoming?: any;
    totalOnHand?: any;
    totalOnway?: any;
    balanceType?: number;
    order?: any;
  };
  body: {
    orders: any;
    entitySubCategoryIDs: string[];
  };
};

export type FindEntityProductsWithProductionPlanProductForecastToBalanceOptions =
  {
    options: {
      page: number;
      take: number;
      entityCategoryID?: string;
      name?: string;
    };
    body?: {
      startDate: string;
      endDate: string;
      entityIDs: string[];
      dateList: string[];
      timeGroupType?: number;
      entitySubCategoryIDs?: string[];
      isExport?: boolean;
    };
  };

export interface ResetEntityProductTotalSupplierQuantityBody {
  entityProductIDs: string[];
  isResetAll: boolean;
}

export interface RecalculateTotalReceivedQuantityBody {
  entityProductIDs: string[];
  isResetAll: boolean;
  orderStatus: number;
  isOnlyCalculateAtCentral?: boolean;
}

export type DivideEntityProductTotalReceivedQuantityAmongOrdersBody = {
  entityProductIDs: string[];
  isResetAll: boolean;
};

export interface FilterEntityProductOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityID?: string;
  status?: number;
}
